import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AnalyticsProvider } from './lib/analytics'
import { initOfflineSync } from './lib/offlineSync'
import './lib/i18n'
import './styles/index.css'

// Replay any offline-queued field records (harvest / activity) once we're back
// online — and drain anything left over from a previous session on load.
initOfflineSync()

// PWA auto-update reload (§137 follow-up). The service worker auto-activates new
// builds (autoUpdate → skipWaiting + clientsClaim), but the OPEN page keeps serving
// the old precached bundle until it reloads — so users saw stale UI after a deploy
// until a manual hard-refresh. When a NEW SW takes control (an update, not the first
// install), reload once to pick up the new build's hashed assets.
if ('serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller
  let reloaded = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded || !hadController) return // skip the first-install claim
    reloaded = true
    window.location.reload()
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AnalyticsProvider>
      <App />
    </AnalyticsProvider>
  </React.StrictMode>,
)
